<template>
	<div class="wrapper">
		<ul class="meter-wrapper">
			<li class="progress-icon-wrapper" v-for="stop in stops" :key="stop">
				<div class="progress-icon">{{stop + 1}}</div>
				<transition name="tracker-progress">
					<div class="travel-icon-wrapper" v-if="stop === stopToShow">
						<img
							class="travel-icon"
							src="@/assets/images/travel-icon.svg" alt="magic mobile icon"
						/>
					</div>
				</transition>
			</li>
		</ul>
	</div>
</template>

<script>

export default {
	name: 'TravelTracker',
	props: {
		totalStops: {
			type: Number,
			required: true,
		},
		currentStop: {
			type: Number,
			required: true,
		},
		traveling: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			nextStop: this.currentStop + 1,
		};
	},
	computed: {
		stops() {
			return [...Array(this.totalStops + 1).keys()];
		},
		stopToShow() {
			return this.traveling ? this.nextStop : this.currentStop;
		},
	},
};
</script>

<style lang="scss" scoped>
	.wrapper {
		width: 100%;
		height: 100%;
		padding: 10% 0;

		@include tablet { padding: 20% 0; }
		@include desktop { padding: 20% 0; }
		@include desktop-sm { padding: 30% 0; }
	}

	.meter-wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column-reverse;
		justify-content: space-between;
		align-items: center;
		position: relative;

		&:after {
			content:"";
			position: absolute;
			height: 90%;
			width: 0;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			margin: auto;
			border-left: 2px dotted $primary-color-dark;
			z-index: -1;
		}
	}

	.progress-icon-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-grow: 1;
		width: 70%;
		position: relative;

		&:last-child {
			.progress-icon { opacity: 0; }
		}
	}

	.progress-icon {
		color: $background-color-dark;
		background: $primary-color-dark;
		border-radius: 100%;
		box-sizing: unset;
		padding: 3%;
		font-family: $body-font-bold;
		font-size: $font-size-base;
		height: 1em;
		width: 1em;
		line-height: 1;
		text-align: center;

		@include mobile {
			font-size: $font-size-x-sm;
			padding: 2%;
		}

		@include desktop { padding: 5%; }
		@include desktop-sm { padding: 5%; }
	}

	.travel-icon-wrapper {
		position: absolute;
		width: 100%;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		z-index: $z-top;

		@include tablet { padding: 5px; }
		@include desktop { padding: 20%; }
		@include desktop-sm { padding: 0; }
	}

	.travel-icon {
		display: block;
		height: 100%;
		margin: 0 auto;
	}

	.progress-icon-wrapper:nth-child(11) {
		&:after {
			content: '';
			position: absolute;
			background-image: url('/wp-content/uploads/vegas-fund.svg');
			background-size: contain;
			background-position: center;
			background-repeat: no-repeat;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			margin: auto;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/game/sidebar/TravelTracker.vue